import { withRouter } from "react-router-dom";
import RoomContainer from "../containers/RoomContainer";

const Post = ({ match: { params } }) => {
  return <RoomContainer id={params.room_id} />;
};

export default withRouter(Post);
